// src/shared/vatBases.js — основанията за неначисляване на ДДС (ПРОМТ-14).
//
// Потребителите не са счетоводители и свободният текст излизаше грешен,
// затова основанието се избира от меню. Образецът е таблицата на Макс
// (01-Текущо\Основания-ДДС-меню.xlsx, лист „Основания").
//
//   value — точно това се записва и се печата във фактурата;
//   label — това вижда човекът: първо с прости думи, после членът.
//
// treatments на групата казва при кой режим се вижда тя — формата не
// държи свои if-ове, нов ред или нов режим се добавя САМО тук.
//   not_registered — фирмата няма ДДС регистрация (ставката е заключена на 0);
//   domestic       — вътрешна доставка с 0 % (виждат се всички);
//   останалите са ключовете на данъчния режим (services/docItems.js).
// suggest на реда: при кой режим той се избира предварително.
//
// Нарочно ги няма: чл. 21, ал. 1 и ал. 3 (мястото е в България — има
// българско ДДС) и чл. 21, ал. 6 (електронни услуги за физ. лица в ЕС
// минават през OSS с ДДС на държавата на клиента, не с 0 %). Редките
// случаи (чл. 17–20, 22–24 и др.) са в „Друго".

export const VAT_BASES = [
  { group: 'Фирмата не е регистрирана по ДДС', treatments: ['not_registered', 'domestic'], items: [
    { value: 'чл. 113, ал. 9 ЗДДС', label: 'Фирмата не е регистрирана по ДДС — чл. 113, ал. 9', suggest: ['not_registered'] },
  ] },
  { group: 'Продажби към чужбина', treatments: ['eu_b2b', 'domestic'], items: [
    { value: 'чл. 53, ал. 1 ЗДДС', label: 'Стоки към фирма в ЕС (ВОД) — чл. 53, ал. 1', suggest: ['eu_b2b'] },
    { value: 'чл. 28 ЗДДС', label: 'Износ на стоки извън ЕС — чл. 28' },
    { value: 'чл. 141 ЗДДС – тристранна операция', label: 'Посредник в тристранна операция — чл. 141' },
  ] },
  { group: 'Услуги, изпълнени извън България (чл. 21)', treatments: ['eu_b2b', 'domestic'], items: [
    { value: 'чл. 21, ал. 2 ЗДДС – обратно начисляване', label: 'Услуга към фирма в чужбина (ЕС или извън ЕС) — чл. 21, ал. 2' },
    { value: 'чл. 21, ал. 4, т. 1 ЗДДС', label: 'Услуга за имот в чужбина (ремонт, архитект, хотел) — чл. 21, ал. 4, т. 1' },
    { value: 'чл. 21, ал. 4, т. 2 ЗДДС', label: 'Превоз на пътници извън България — чл. 21, ал. 4, т. 2' },
    { value: 'чл. 21, ал. 4, т. 3 ЗДДС', label: 'Билети / вход за събитие в чужбина, за фирма — чл. 21, ал. 4, т. 3' },
    { value: 'чл. 21, ал. 4, т. 4 ЗДДС', label: 'Услуга, извършена в чужбина, за физическо лице (събитие, работа по вещ) — чл. 21, ал. 4, т. 4' },
    { value: 'чл. 21, ал. 4, т. 5 ЗДДС', label: 'Ресторант / кетъринг в чужбина — чл. 21, ал. 4, т. 5' },
    { value: 'чл. 21, ал. 5 ЗДДС', label: 'Софтуер, права, консултации, реклама за физическо лице извън ЕС — чл. 21, ал. 5' },
  ] },
  { group: 'Обратно начисляване в България', treatments: ['reverse_charge', 'domestic'], items: [
    { value: 'чл. 163а ЗДДС – обратно начисляване', label: 'Отпадъци, зърно и др. по Приложение 2 — чл. 163а', suggest: ['reverse_charge'] },
  ] },
  { group: 'Освободени доставки', treatments: ['exempt', 'domestic'], items: [
    { value: 'чл. 39 ЗДДС', label: 'Здравеопазване — чл. 39' },
    { value: 'чл. 40 ЗДДС', label: 'Социални грижи — чл. 40' },
    { value: 'чл. 41 ЗДДС', label: 'Образование, спорт — чл. 41' },
    { value: 'чл. 42 ЗДДС', label: 'Култура — чл. 42' },
    { value: 'чл. 43 ЗДДС', label: 'Вероизповедания — чл. 43' },
    { value: 'чл. 44 ЗДДС', label: 'Нестопански характер — чл. 44' },
    { value: 'чл. 45, ал. 1 ЗДДС', label: 'Земя (не УПИ) — чл. 45, ал. 1' },
    { value: 'чл. 45, ал. 3 ЗДДС', label: 'Стара сграда (не нова) — чл. 45, ал. 3' },
    { value: 'чл. 45, ал. 7 ЗДДС', label: 'Наем на жилище на физическо лице — чл. 45, ал. 7' },
    { value: 'чл. 46 ЗДДС', label: 'Финансови услуги — чл. 46' },
    { value: 'чл. 47 ЗДДС', label: 'Застраховане — чл. 47' },
    { value: 'чл. 48 ЗДДС', label: 'Хазарт — чл. 48' },
    { value: 'чл. 49 ЗДДС', label: 'Пощенски марки и др. — чл. 49' },
    { value: 'чл. 161 ЗДДС', label: 'Инвестиционно злато — чл. 161' },
  ] },
];

// „Друго" не е запис в списъка: стойността му е написаното от човека.
export const OTHER_LABEL = 'Друго — ще го напиша сам…';
export const OTHER_MAX = 200;

// Сравнява без главни/малки букви и без празните места:
// „ЧЛ. 53,  ал. 1 ЗДДС" е същото като „чл. 53, ал. 1 ЗДДС".
const norm = (s) => String(s == null ? '' : s).toLowerCase().replace(/\s+/g, '');

export function findBasis(text) {
  const k = norm(text);
  if (!k) return null;
  for (const g of VAT_BASES) {
    for (const it of g.items) if (norm(it.value) === k) return { ...it, group: g.group };
  }
  return null;
}

// Групите, които се виждат при даден режим (без „Друго" — то е винаги).
export function basesFor(treatment) {
  return VAT_BASES.filter((g) => g.treatments.includes(treatment));
}

// Предварително избраното основание при режима, или '' — тогава човекът
// избира сам (освободената доставка няма едно основание).
export function suggestedBasis(treatment) {
  for (const g of VAT_BASES) {
    for (const it of g.items) if (it.suggest && it.suggest.includes(treatment)) return it.value;
  }
  return '';
}
